export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑市场',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
  },
  {
    text: that.$l('menu_text_delete') || '删除市场',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
  },
]
